import { ConsoleOperation } from "namirasoft-core";
import { IStream } from "./IStream";
import { Log } from "./Log";
import { LogLevel } from './LogLevel';

export class StreamConsole implements IStream
{
    write(log: Log, formated: { pre: string[], messages: string[], post: string[] }): void
    {
        let getFormatted = (data: string) =>
        {
            if (log.level == LogLevel.Trace)
                return ConsoleOperation.formatTraceColor(data);
            if (log.level == LogLevel.Verbose)
                return ConsoleOperation.formatLogColor(data);
            if (log.level == LogLevel.Debug)
                return ConsoleOperation.formatDebugColor(data);
            if (log.level == LogLevel.Info)
                return ConsoleOperation.formatInfoColor(data);
            if (log.level == LogLevel.Success)
                return ConsoleOperation.formatSuccessColor(data);
            if (log.level == LogLevel.Warning)
                return ConsoleOperation.formatWarningColor(data);
            if (log.level == LogLevel.Error)
                return ConsoleOperation.formatErrorColor(data);
            if (log.level == LogLevel.Critical)
                return ConsoleOperation.formatErrorColor(data);
            if (log.level == LogLevel.Fatal)
                return ConsoleOperation.formatErrorColor(data);
            return ConsoleOperation.formatLogColor(data);
        }
        let preline: string[] = formated.pre.map(ConsoleOperation.formatLogColor);
        let msgline: string[] = formated.messages.map(getFormatted);
        let postline: string[] = formated.post.map(ConsoleOperation.formatLogColor);
        let lines = [...preline, ...msgline, ...postline];
        console.log(lines.join("\n"));
    }
}